import { formatDecimal } from "../../../utils";

export const toTableRowItems = (items: DSProductWithDifference[]) =>
  items.map((item: DSProductWithDifference) => ({
    id: item.id,
    orderNumber: item.orderNumber,
    supplierCode: item.supplierCode,
    supplierName: item.supplierName || '',
    shopCode: item.shopCode || '',
    deliveryDate: item.deliveryDate || '',
    articleCode: item.articleCode || '',
    articleName: item.articleName || '',
    eanCode: item.eanCode || '',
    scannedCode: item.scannedCode || '',
    measureUnit: item.measureUnit || '',
    orderedQuantity: formatDecimal(item.orderedQuantity) || '',
    receivedQuantity: formatDecimal(item.receivedQuantity) || '',
    missingQuantity: formatDecimal(item.missingQuantity) || '',
    orderLineNumber: item.orderLineNumber || '',
  }))
